import React from "react";
import Icon from "../../assets/icons/Icon";
import Button from "./Button";
import { isMobileView } from "./CommonFunctions";

const PopupModal = ({
  size = "large",
  setPopUp,
  title,
  children,
  buttons,
  saveClick,
  secondbtnname = "ok",
  handleClose = null,
  primaryBtnDisabled,
  secondaryBtnDisabled,
}) => {
  // Use default sizing if size is "small" or "large"
  // Otherwise, use the custom sizing string provided.
  let containerClasses;
if (size === "small") {
  containerClasses =
    "w-screen h-screen sm:w-[80%] lg:w-[35%] sm:h-[80vh] lg:h-[65vh]";
} else if (size === "medium") {
  containerClasses =
    "w-screen h-screen sm:w-[80%] lg:w-[42%] sm:h-[80vh] lg:h-[72vh]";
} else if (size === "large") {
  containerClasses =
    "w-screen h-screen sm:w-[80%] lg:w-[50%] sm:h-[80vh] lg:h-[80vh]";
} else {
  containerClasses = size; 
  // Expect a complete class string like:
  // "w-[60%] h-[70vh]"
}


  const closePopUp = () => {
    if (handleClose) {
      handleClose();
    }
    setPopUp(false);
  };

  return (
    <div className="fixed inset-0 bg-[#12186721] flex justify-center items-center z-100">
      <div
        className={`${isMobileView() ? "w-[95%] max-h-[95%]" :  `${containerClasses}  `} bg-white rounded-lg shadow-lg  flex flex-col relative`}
      >
        <div
          className={`flex rounded-t-lg justify-between items-center py-3 text-lg border-b border-gray-300 text-[#FFFFFF] px-4 primary-gradient`}
        >
          <h2 className="text-xl font-bold flex items-center">{title}</h2>
          <span
            className="w-7 hover:scale-105 transition-transform duration-200 cursor-pointer"
            onClick={closePopUp}
          >
            <Icon type="remove" />
          </span>
        </div>

        <div className="flex flex-col gap-4 p-6 flex-1 overflow-y-auto custom-scrollable">
          <div>{children}</div>
        </div>

        {buttons && (
          <div className="flex justify-between gap-4 p-2 border-t border-gray-300">
            <Button
              type="secondary"
              disabled={secondaryBtnDisabled}
              iconType={"roundedRemove"}
              onClick={closePopUp}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={primaryBtnDisabled}
              iconType={"save"}
              onClick={saveClick}
            >
              {secondbtnname || "save"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupModal;
